import ContentLoader, { Rect } from 'react-content-loader/native'
import { GetProps, Stack } from 'tamagui'
import { useThemeColor } from '@hooks/useThemeColor'

type ShimmerProps = GetProps<typeof Stack>

export function Shimmer(props: ShimmerProps) {
  const baseColor = useThemeColor('skeleton-base')
  const highlightColor = useThemeColor('skeleton-highlight')
  return (
    <Stack {...props}>
      <ContentLoader
        animate
        title=""
        width="100%"
        height="100%"
        backgroundColor={baseColor}
        foregroundColor={highlightColor}
      >
        <Rect x="0" y="0" rx="5" ry="5" width="100%" height="100%" />
      </ContentLoader>
    </Stack>
  )
}
